import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './assessments-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import AssessmentEntry from './assessment-entry/assessment-entry.container'
import {
  BulkActionProvider,
  SelectAllButton
} from 'pobble-components/dist/bulk-action'
import BulkActions from './bulk-actions/bulk-actions.container'
import CreateAssessement from '../../dialogs/create-assessment/create-assessment.container'

const AssessmentsTable = ({
  classes,
  assessments,
  onSelectAll,
  onDeselectAll,
  noAssessments
}) =>
  noAssessments ? (
    <span>This pupil doesn't have any moderation files yet</span>
  ) : (
    <Fragment>
      <BulkActionProvider entities={assessments}>
        <Table>
          <thead>
            <tr>
              <HeadCell className={classes.all}>
                <SelectAllButton />
              </HeadCell>
              <HeadCell className={classes.date}>Date</HeadCell>
              <HeadCell className={classes.left}>Title</HeadCell>
              <HeadCell className={classes.contributors}>Contributors</HeadCell>
              <HeadCell className={classes.conclusion}>Conclusion</HeadCell>
              <HeadCell className={classes.contextMenuCell}>
                <BulkActions />
              </HeadCell>
            </tr>
          </thead>
          <tbody>
            {assessments.map(assessment => (
              <AssessmentEntry key={assessment.id} id={assessment.id} />
            ))}
          </tbody>
        </Table>
      </BulkActionProvider>
      <CreateAssessement />
    </Fragment>
  )

export default injectSheet(styles)(AssessmentsTable)
